export default {
  userInfo: null,
};
